import { ReactNode } from "react";
import { Address } from "../api/types/address";

export const formatAddress = (address: Address): ReactNode => {
  return (
    <div>{address.name}, {address.streetDetails ? `${address.streetDetails}, ` : ""} {address.street}, {address.city}</div>
  )
}
